import { useState, useEffect, useCallback } from 'react';
import NavButtons from '../components/NavButtons';
import ContentBlocks from '../components/ContentBlocks';

function CarouselScreen({ heading, blocks, images = [], interval = 6000, onBack, showBack = true }) {
  const [index, setIndex] = useState(0);

  const prev = () => setIndex(i => (i - 1 + images.length) % images.length);
  const next = useCallback(() => setIndex(i => (i + 1) % images.length), [images.length]);

  useEffect(() => {
    if (images.length < 2) return;
    const id = setInterval(next, interval);
    return () => clearInterval(id);
  }, [next, interval, images.length]);

  return (
    <div className="screen">
      <div className="screen-content">
        <h1 className="screen-title">{heading}</h1>
        <div className="carousel">
          <button className="carousel-btn" onClick={prev} aria-label="Previous">&#8249;</button>
          <img
            className="carousel-image"
            src={images[index]?.src}
            alt={images[index]?.alt ?? ''}
          />
          <button className="carousel-btn" onClick={next} aria-label="Next">&#8250;</button>
        </div>
        <div className="carousel-dots">
          {images.map((_, i) => (
            <button
              key={i}
              className={`carousel-dot${i === index ? ' active' : ''}`}
              onClick={() => setIndex(i)}
              aria-label={`Go to image ${i + 1}`}
            />
          ))}
        </div>
        <ContentBlocks blocks={blocks} />
      </div>
      <NavButtons onBack={onBack} showBack={showBack} showNext={false} />
    </div>
  );
}

export default CarouselScreen;
